/* AllPnC Globo Premium Configurator - Phase 4 */
(()=>{
const RULES=[
{key:'installation',re:/^Professional Installation$/i,kind:'installation'},
{key:'premium',re:/^Premium Compatible (?:Toners|Bundles)(?:\s*\(Recommended\))?/i,kind:'toner',badge:'Recommended'},
{key:'genuine',re:/^(?:Genuine Manufacturer|Genuine OEM) (?:Toners|Bundles)/i,kind:'toner'},
{key:'economy',re:/^Economy Compatible (?:Toners|Bundles)/i,kind:'toner'},
{key:'paper',re:/^Paper Handling & Finishing(?:\s*\((\d+)\))?$/i,kind:'accessory'},
{key:'other',re:/^Other Printer Options(?:\s*\((\d+)\))?$/i,kind:'accessory'},
{key:'memory',re:/^Memory & Storage(?:\s*\((\d+)\))?$/i,kind:'accessory'},
{key:'connectivity',re:/^Connectivity & Networking(?:\s*\((\d+)\))?$/i,kind:'accessory'},
{key:'warranty',re:/^Warranty & Support(?:\s*\((\d+)\))?$/i,kind:'accessory'}];

const HELP=[
'professional installation includes',
'delivery charges are calculated',
'add compatible paper trays',
'expand your printer with compatible',
'add compatible memory',
'add compatible networking',
'add other compatible hardware',
'add an available warranty',
'oem quality for maximum performance',
'best balance of quality',
'a cost-effective option for everyday printing',
'excellent print quality',
'original manufacturer toner',
'original manufacturer toner bundles'
];

const txt=e=>(e?.textContent||'').replace(/\s+/g,' ').trim();
const rule=t=>RULES.find(r=>r.re.test(t));
const candidates='label,legend,h1,h2,h3,h4,h5,h6,[class*="label"],[class*="title"]';

function count(el){
  let n=0;
  for(const x of el.querySelectorAll(candidates)){
    if(rule(txt(x)))n++;
  }
  return n;
}

function root(h){
  let c=h,b=h.parentElement;
  while(c&&c.parentElement&&c.parentElement!==document.body){
    const p=c.parentElement,n=count(p);
    if(n===1)b=p;
    if(n>1)break;
    c=p;
  }
  return b;
}

function help(s,h){
  for(const e of s.querySelectorAll('[class*="help"],[class*="description"],small,p,span,div')){
    if(e===h||e.contains(h))continue;
    const t=txt(e).toLowerCase();
    if(t&&t.length<260&&HELP.some(x=>t.startsWith(x)))return e;
  }
  return null;
}

function enhance(h,r){
  if(h.dataset.allpncEnhanced)return;

  const s=root(h);
  if(!s||s.dataset.allpncEnhanced)return;

  const collapse=
    r.kind==='accessory' ||
    r.key==='genuine' ||
    r.key==='economy';

  s.dataset.allpncEnhanced='1';
  h.dataset.allpncEnhanced='1';

  if(r.key==='premium'){
    h.textContent='Premium Compatible ' +
      (txt(h).toLowerCase().includes('bundle') ? 'Bundles' : 'Toners');
  }

  if(r.kind==='accessory'){
    h.textContent=txt(h).replace(/\s*\(\d+\)\s*$/,'');
  }

  s.classList.add(
    'allpnc-gpo-section',
    `allpnc-gpo-section--${r.kind}`,
    `allpnc-gpo-section--${r.key}`
  );

  if(r.key==='premium'){
    s.classList.add('allpnc-gpo-section--premium');
  }

  if(r.kind==='toner'){
    s.classList.add('allpnc-gpo-section--toner');
  }

  const hp=help(s,h);
  const head=document.createElement('div');
  head.className='allpnc-gpo-header';

  h.parentNode.insertBefore(head,h);
  head.appendChild(h);
  h.classList.add('allpnc-gpo-heading');

  if(r.badge){
    const b=document.createElement('span');
    b.className='allpnc-gpo-badge';
    b.textContent=r.badge;
    head.appendChild(b);
  }

  if(collapse){
    const c=document.createElement('span');
    c.className='allpnc-gpo-chevron';
    c.setAttribute('aria-hidden','true');
    head.appendChild(c);
    head.setAttribute('role','button');
    head.tabIndex=0;
    head.setAttribute('aria-expanded','false');
  }

  if(hp){
    hp.classList.add('allpnc-gpo-help');
    head.insertAdjacentElement('afterend',hp);
  }

  const body=document.createElement('div');
  body.className='allpnc-gpo-body';

  for(const node of [...s.childNodes]){
    if(node===head||node===hp)continue;
    if(node.nodeType===3&&!node.textContent.trim())continue;
    body.appendChild(node);
  }

  s.appendChild(body);

  if(collapse){
    s.classList.add('allpnc-gpo-section--collapsible','is-collapsed');

    const toggle=()=>{
      const open=s.classList.contains('is-collapsed');
      s.classList.toggle('is-collapsed',!open);
      head.setAttribute('aria-expanded',String(open));
    };

    head.addEventListener('click',toggle);

    head.addEventListener('keydown',e=>{
      if(e.key==='Enter'||e.key===' '){
        e.preventDefault();
        toggle();
      }
    });
  }
}

function scan(){
  for(const h of document.querySelectorAll(candidates)){
    const t=txt(h);
    const r=rule(t);
    if(r)enhance(h,r);
  }
}

let timer;

const observer=new MutationObserver(()=>{
  clearTimeout(timer);
  timer=setTimeout(scan,80);
});

function start(){
  scan();
  observer.observe(document.body,{childList:true,subtree:true});
}

document.readyState==='loading'
  ?document.addEventListener('DOMContentLoaded',start,{once:true})
  :start();
})();
